import { Component, inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { SystemCheck } from '@services/system-check';
import { SystemTestItemComponent } from '../system-test-item/system-test-item.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lv-system-check',
  templateUrl: 'system-check.component.html',
  styleUrls: ['system-check.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, SystemTestItemComponent, TranslateModule]
})
export class SystemCheckComponent implements OnInit, OnDestroy {
  @Input() audio = false;

  webcamOk = false;
  websocketsOk = true;

  private systemCheck = inject(SystemCheck);

  get browserName(): string {
    return this.systemCheck.browserName;
  }

  get microphoneOk(): boolean {
    return this.systemCheck.microphone;
  }

  get speakersOk(): boolean {
    return this.systemCheck.speakers;
  }

  get webrtcOk(): boolean {
    return this.systemCheck.webrtc;
  }

  get browserOk(): boolean {
    return this.systemCheck.browser;
  }

  get audioOk(): boolean {
    return this.microphoneOk && this.speakersOk;
  }

  get videoOk(): boolean {
    return this.webcamOk && this.webrtcOk;
  }

  get browserVersion() {
    return this.systemCheck.browserVersion;
  }

  ngOnInit() {
    this.doSystemCheck();
  }

  ngOnDestroy() {
    this.systemCheck.stop();
  }

  async doSystemCheck() {
    await this.systemCheck.start();
    this.websocketsOk = await this.systemCheck.testWebsockets();
    this.webcamOk = await this.systemCheck.testWebcam();
  }

  everythingWorks(): boolean {
    if (this.audio) {
      return this.websocketsOk && this.audioOk && this.videoOk;
    }
    return this.websocketsOk && this.videoOk;
  }

  browserCompatibility(): boolean {
    return this.browserOk && this.websocketsOk && this.webrtcOk;
  }

  onRetry() {
    this.doSystemCheck();
  }
}
